/**
 * A default role for an organization (from the identity service). By its existence, any identity
 * created with default permissions in the org is granted the referenced role.
 */
export interface DefaultRole {
  id: string;
  organizationId: string;
  name: string;
  roleType: 'Standard' | 'Custom';
  // id of the role as defined by the authorization service (matches standardRoleId on grants)
  roleId: string;
}

/**
 * Template class for all MOP resources with built in helper methods
 */
export class Organization {
  public name: string;
  public label: string;
  public auth0ConnectionId: string;
  public identityProviderName: string;
  public id: string;
  public selected = false;
  public deleted = false;
  public active = true;
  public identityProviders = [];
  public defaultRoles: DefaultRole[] = [];

  // Default nested property that should exist on all resources
  public _links = {
    self: {
      href: null,
    },
  };

  public hash: string;

  constructor(object) {
    const keys = Object.keys(object);

    // TODO - Figure out how to do inflection so only public properties are populated
    for (const key of keys) {
      this[key] = object[key];
    }

    this.hash = btoa(this._links.self.href);

    return this;
  }

  public getId() {
    if (this._links.self.href != null) {
      return this._links.self.href.split('/').pop();
    } else {
      return null;
    }
  }

  public getSelfLink() {
    return this._links.self.href;
  }

  public unhashLink() {
    return atob(this.hash);
  }

  public getLinkedResource(linkName: string) {
    if (this._links[linkName].href !== undefined) {
      return this._links[linkName].href;
    } else {
      return null;
    }
  }

  public getLinkedResourceId(linkName: string) {
    if (this._links[linkName] !== undefined && this._links[linkName]['href'] !== undefined) {
      return this._links[linkName]['href'].split('/').pop();
    } else {
      return null;
    }
  }
}
